import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './Error500Layout.scss';

const errorImgSrc =
    'https://internal.1stdibscdn.com/public/dist/ea0cd2bc2590150dbc1665eb44d3dd95.jpg';

const Error500Layout = () => {
    const messageLink = (
        <a href="" title="Reload current page">
            <FormattedMessage
                id="dbl.Error500Layout.messageLink"
                defaultMessage="try loading this page again"
            />
        </a>
    );

    return (
        <div className={styles.container}>
            <div className={styles.info}>
                <h3 className={styles.header}>
                    <FormattedMessage
                        id="dbl.Error500Layout.title"
                        defaultMessage="Sorry, we're currently experiencing technical difficulties."
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id="dbl.Error500Layout.message"
                        defaultMessage="We know your time is valuable. Give us a few seconds and {messageLink}."
                        values={{ messageLink }}
                    />
                </p>
            </div>
            <div className={styles.imageWrap}>
                <img className={styles.image} src={errorImgSrc} alt="PATEK PHILIPPE Wristwatch" />
            </div>
        </div>
    );
};

export default Error500Layout;
